// extracted by mini-css-extract-plugin
module.exports = {"date":"ProcedureTableInfo_date__1RlY4","head":"ProcedureTableInfo_head__Zngzu"};